import React from "react";
import { BusinessAnalyticsLayout } from "../layouts/BusinessAnalyticsLayout";
import { BusinessAnalyticsInstance } from "../utils/businessAnalyticsClass";
import { Dashboard } from "./DashboardPage";
import { ZipCodeInputComponent, GlobalUserAnalyticsDashboard } from "../components";
import { Button } from "react-bootstrap";

export const GlobalAnalyticsPage = () => {
    const [users, setUsers] = React.useState<any[]>([]);
    const [zipCodes, setZipCodes] = React.useState<string[]>([]);
    const [uniqueZipCodes, setUniqueZipCodes] = React.useState<string[]>([]);
    const initializeBusinessAnalytics = async () => {
        await BusinessAnalyticsInstance.initialize();
    };

    const getUserData = async () => {
        const res = await BusinessAnalyticsInstance.getUserLocationAnalytics(zipCodes, 1, 'venue');
        setUsers(res);
        const uniqueZipCodes: any[] = Array.from(new Set(res.map((user: any) => user.homeZipCode)));
        setUniqueZipCodes(uniqueZipCodes);
    }

    return (
        <Dashboard header="Location Analytics">
            <ZipCodeInputComponent setZipCodes={setZipCodes} zipCodes={zipCodes} />
            <button onClick={getUserData}>Initialize Business Analytics</button>
            <GlobalUserAnalyticsDashboard users={users} zipCodes={zipCodes} />
        </Dashboard>
    );
};